/**
 * Chip da SITUAÇÃO (017, FR-001) — o idioma comum que as telas simples falam:
 * o mesmo componente, as mesmas cores, na lista e no atendimento aberto (o
 * Completo mostrava o status com cores trocadas entre lista e detalhe). O
 * rótulo vem do perfil do tenant ("Aguardando associação" no rastreamento).
 */
import { situationLabel, type TicketSituation } from '@erp/shared';
import { AlarmClock } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useTerms } from '@/shared/tenant-profile';

const SITUATION_CHIP: Record<TicketSituation, string> = {
  new: 'border-[#91CAFF] bg-[#E6F4FF] text-[#1677FF]',
  in_progress: 'border-[#87E8DE] bg-[#E6FFFB] text-[#08979C]',
  waiting_client: 'border-[#FFE58F] bg-[#FFFBE6] text-[#D48806]',
  waiting_contact: 'border-[#FFE58F] bg-[#FFFBE6] text-[#D48806]',
  waiting_third_party: 'border-[#D3ADF7] bg-[#F9F0FF] text-[#722ED1]',
  done: 'border-[#B7EB8F] bg-[#F6FFED] text-[#389E0D]',
  canceled: 'border-[#FFA39E] bg-[#FFF1F0] text-[#CF1322]',
};

export function SituationChip({
  situation,
  stuck = false,
  className,
}: {
  situation: TicketSituation;
  /** parado na etapa além do prazo dela (017, FR-008) */
  stuck?: boolean;
  className?: string;
}) {
  const terms = useTerms();
  return (
    <span className={cn('inline-flex items-center gap-1', className)}>
      <span
        className={cn(
          'inline-flex h-[22px] w-fit shrink-0 items-center rounded-[4px] border px-2 text-xs font-medium whitespace-nowrap',
          SITUATION_CHIP[situation]
        )}
      >
        {situationLabel(terms, situation)}
      </span>
      {stuck ? (
        <span title={`Parado na ${terms.stage} além do prazo`} className="text-[#CF1322]">
          <AlarmClock className="size-3.5" aria-label={`Parado na ${terms.stage}`} />
        </span>
      ) : null}
    </span>
  );
}
